import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

import { computed, reactive, ref } from 'vue'
import { RuleItem } from 'async-validator'
import { ElForm } from 'element-plus'
import { commonCase, dollarsToCents } from '@/helpers/strings'

import {
  FinishTripPaymentPayload,
  FinishTripPaymentKapitalPayload,
  TripExtended,
} from '@/models/trip'
import { useTripsStore } from '@/store/trips'


export default /*@__PURE__*/_defineComponent({
  __name: 'FinishTripPayment',
  props: {
    trip: {}
  },
  setup(__props: any) {

const props = __props

const tripStore = useTripsStore()
const loading = ref(false)
const formRef = ref<InstanceType<typeof ElForm>>()
const selectedAction = ref<
  FinishTripPaymentPayload['action'] | FinishTripPaymentKapitalPayload['action']
>('charge')

// Check if trip has Kapital payments (similar to FinanceSection.vue)
const hasKapitalPayments = computed(() => {
  return props.trip.taksit !== null && props.trip.trip_payments_kapital
})

// Auto-detect payment gateway based on trip data
const paymentGateway = ref<'yigim' | 'kapital'>(
  hasKapitalPayments.value ? 'kapital' : 'yigim'
)

const form = reactive<FinishTripPaymentPayload['payload']>({
  amount: 0,
  comment: '',
  transactionType: 'deposit',
})

const kapitalForm = reactive<Omit<FinishTripPaymentKapitalPayload, 'action'>>({
  amount: 0,
  comment: '',
})

const yigimActions: FinishTripPaymentPayload['action'][] = [
  'charge',
  'unfreeze',
  'freeze',
  'refund',
]

const kapitalActions: FinishTripPaymentKapitalPayload['action'][] = [
  'freeze',
  'unfreeze',
  'charge',
  'refund',
  // 'partial_refund',
]

const availableActions = computed(() => {
  return paymentGateway.value === 'yigim' ? yigimActions : kapitalActions
})

const rules = computed<Record<string, RuleItem[]>>(() => ({
  amount: [
    {
      validator: (rule, value) => {
        if (
          paymentGateway.value === 'kapital' &&
          selectedAction.value === 'unfreeze'
        ) {
          return true
        }
        return value > 0
      },
      message: 'Amount should be more than 0',
    },
  ],
}))

const onPaymentGatewayChange = () => {
  // Reset action when switching payment gateway
  selectedAction.value = availableActions.value[0]
  form.amount = 0
  kapitalForm.amount = 0
}

const onSubmit = () => {
  formRef.value?.validate(async isValid => {
    if (isValid) {
      try {
        loading.value = true
        let success = false

        if (paymentGateway.value === 'yigim') {
          success = await tripStore.finishPayment(props.trip.id, {
            payload: {
              ...form,
              amount: Math.round(dollarsToCents(form.amount)),
            },
            action: selectedAction.value as FinishTripPaymentPayload['action'],
          })
        } else {
          success = await tripStore.finishPaymentKapital(props.trip.id, {
            action: selectedAction.value as FinishTripPaymentKapitalPayload['action'],
            amount: Math.round(dollarsToCents(kapitalForm.amount || 0)),
            comment: kapitalForm.comment,
          })
        }

        if (success) {
          formRef.value?.resetFields()
          form.comment = ''
          form.internal_comment = ''
          kapitalForm.comment = ''
          tripStore.getTripDetails(props.trip.id)
        }
      } catch (error) {
        error
      } finally {
        loading.value = false
      }
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_radio_group, {
      modelValue: selectedAction.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedAction).value = $event)),
      size: "large",
      onChange: _cache[1] || (_cache[1] = ($event: any) => (
      paymentGateway.value === 'yigim' ? (form.amount = 0) : (kapitalForm.amount = 0)
    ))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableActions.value, (item) => {
          return (_openBlock(), _createBlock(_component_el_radio_button, {
            key: item,
            label: item
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(commonCase)(item, true)), 1)
            ]),
            _: 2
          }, 1032, ["label"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(ElForm), {
      ref_key: "formRef",
      ref: formRef,
      "label-position": "top",
      model: paymentGateway.value === 'yigim' ? form : kapitalForm,
      rules: rules.value,
      onSubmit: _withModifiers(onSubmit, ["prevent"])
    }, {
      default: _withCtx(() => [
        (!(paymentGateway.value === 'kapital' && selectedAction.value === 'unfreeze'))
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "Amount",
              prop: "amount"
            }, {
              default: _withCtx(() => [
                (paymentGateway.value === 'yigim')
                  ? (_openBlock(), _createBlock(_component_el_input_number, {
                      key: 0,
                      modelValue: form.amount,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.amount) = $event)),
                      min: 0,
                      precision: 2,
                      step: 0.1
                    }, null, 8, ["modelValue"]))
                  : (_openBlock(), _createBlock(_component_el_input_number, {
                      key: 1,
                      modelValue: kapitalForm.amount,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((kapitalForm.amount) = $event)),
                      min: 0,
                      precision: 2,
                      step: 0.1
                    }, null, 8, ["modelValue"]))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (paymentGateway.value === 'yigim')
          ? (_openBlock(), _createBlock(_component_el_row, {
              key: 1,
              gutter: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "Transaction Type" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: form.transactionType,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.transactionType) = $event)),
                          placeholder: "Select amount type"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['deposit', 'service'], (item) => {
                              return _createVNode(_component_el_option, {
                                key: item,
                                label: _unref(commonCase)(item, true),
                                value: item
                              }, null, 8, ["label", "value"])
                            }), 64))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "Comment" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.comment,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.comment) = $event)),
                          type: "textarea"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "Internal Comment" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.internal_comment,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.internal_comment) = $event)),
                          type: "textarea"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_row, {
              key: 2,
              gutter: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "Comment" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: kapitalForm.comment,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((kapitalForm.comment) = $event)),
                          type: "textarea"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })),
        _createVNode(_component_el_button, {
          "native-type": "submit",
          disabled: loading.value,
          loading: loading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(paymentGateway.value === 'yigim'
          ? 'Finish payment'
          : 'Execute Kapital operation'), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ], 64))
}
}

})